import React, { FC, useEffect } from 'react'
import { useParams, Redirect, useLocation } from 'react-router-dom'
import ROUTES from '../../utils/routes'
import useAffiliateTrack from '../../../redux/affiliate-track/useAffiliateTrack'

const AffiliateTrack: FC = () => {
  const { actions: { setAffiliate, trackLinkClick } } = useAffiliateTrack()
  const { affiliateId } = useParams()
  const { search } = useLocation()

  useEffect(() => {
    trackLinkClick(affiliateId)
    setAffiliate(affiliateId)
  }, [affiliateId])

  return <Redirect to={{ pathname: ROUTES.user.signup, search }} />
}

export default AffiliateTrack
